import React from 'react';
import { setCurrentView } from 'core/utils';
import { ExitScanModeDetailViewStore } from 'modules/order/stores';
import { ExitScanModeDetailTemplate } from 'themes/modules/order/pages';

@setCurrentView(rootStore => new ExitScanModeDetailViewStore(rootStore), 'exitScanModeDetailViewStore')
class ExitScanModeDetail extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <ExitScanModeDetailTemplate {...this.props} />;
	}
}

export default ExitScanModeDetail;



// WEBPACK FOOTER //
// ./src/modules/order/pages/ExitScanModeDetail.jsx